import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "top-main-content" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideNavigation = _resolveComponent("SideNavigation")!
  const _component_FreeTrial = _resolveComponent("FreeTrial")!
  const _component_DreTray = _resolveComponent("DreTray")!
  const _component_AppMobileHeader = _resolveComponent("AppMobileHeader")!
  const _component_AppMobileFooter = _resolveComponent("AppMobileFooter")!

  return (_ctx.$store.getters['user/isAuthorized'])
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _hoisted_1,
        _createVNode(_component_SideNavigation, { "onUserAction:resizePanel": _ctx.resizePanelAction }, null, 8, ["onUserAction:resizePanel"]),
        _createVNode(_component_FreeTrial),
        _createVNode(_component_DreTray),
        _createVNode(_component_AppMobileHeader),
        _createElementVNode("main", {
          id: "main",
          class: _normalizeClass([_ctx.isPanelMaximized && 'panel--maximized', _ctx.peekabooOpen && 'peekaboo--open']),
          role: "main"
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2),
        _createVNode(_component_AppMobileFooter, {
          onOpenDreTray: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDreTray()))
        })
      ], 64))
    : _createCommentVNode("", true)
}